import { Provider } from '@angular/core';

import { VacationsUseCasesImpl } from '@app/domain/use-cases/mot/vacations/vacations.use-cases';
import { VACATIONS_USE_CASES } from '@app/domain/use-cases/mot/vacations/vacations.use-cases.contract';

export const vacationsUseCasesProvider: Provider = {
  provide: VACATIONS_USE_CASES,
  useClass: VacationsUseCasesImpl
};
